import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaShieldAlt, FaEye, FaRocket, FaHandshake, 
  FaUmbrella, FaAward, FaGlobe, FaCheckCircle,
  FaCarAlt, FaHeartbeat, FaHome, FaUserShield, FaFileAlt,
  FaCar, FaMotorcycle, FaHeart, FaBriefcase, FaPlane
} from 'react-icons/fa';
import InsurancePartners from '../components/layout/InsurancePartners';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();
  const features = [
    { icon: <FaShieldAlt />, title: 'Security', description: 'Your data and policies are secure with us' },
    { icon: <FaEye />, title: 'Transparency', description: 'Clear terms and honest communication' },
    { icon: <FaRocket />, title: 'Efficiency', description: 'Quick processing and fast claim settlements' },
    { icon: <FaHandshake />, title: 'Trustworthy', description: 'Years of experience and reliability' },
    { icon: <FaUmbrella />, title: 'Income Protection', description: 'Safeguard your financial future' },
    { icon: <FaAward />, title: 'Experience', description: 'Expert team with deep industry knowledge' },
    { icon: <FaGlobe />, title: 'Global Reach', description: 'Worldwide coverage and support' },
    { icon: <FaCheckCircle />, title: 'Assurance', description: 'Peace of mind with comprehensive coverage' }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-inner container">
          <div className="hero-left">
            <h1 className="hero-title fade-in">BeReliable Insurance</h1>
            <h2 className="hero-subheading fade-in">Be Reliable, Be Secure</h2>
            <p className="hero-description fade-in">
              Your trusted insurance partner in Vadodara, Gujarat — offering transparent,
              fast and reliable insurance solutions.
            </p>
            <div className="hero-buttons fade-in">
              <Link to="/inquiry" className="btn hero-primary-btn">
                Get Insurance Quote
              </Link>
              <Link to="/about" className="btn hero-secondary-btn">
                Learn More
              </Link>
            </div>
          </div>

          <div className="hero-right">
            <div className="hero-illustration">
              <div className="hero-illustration-main">
                <FaUserShield className="hero-illustration-icon main" />
              </div>
              <div className="hero-illustration-orbit orbit-top-left">
                <FaCarAlt className="hero-illustration-icon" />
              </div>
              <div className="hero-illustration-orbit orbit-top-right">
                <FaHeartbeat className="hero-illustration-icon" />
              </div>
              <div className="hero-illustration-orbit orbit-bottom-left">
                <FaHome className="hero-illustration-icon" />
              </div>
              <div className="hero-illustration-orbit orbit-bottom-right">
                <FaFileAlt className="hero-illustration-icon" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Slider */}
      <InsurancePartners />

      {/* What We Offer */}
<div className="container">
  <WhatWeOffer navigate={navigate} />
</div>

      {/* Why Choose Us */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card card fade-in">
                <div className="feature-icon">{feature.icon}</div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to Protect What Matters Most?</h2>
          <p className="cta-description">
            Get a personalized insurance quote in minutes. Our experts are here to help you find the perfect coverage.
          </p>
          <Link to="/inquiry" className="btn btn-primary btn-large">
            Get Your Quote Now
          </Link>
        </div>
      </section>
    </div>
  );
};

export function WhatWeOffer({ navigate }) {
  const categories = [
    { label: "Car", icon: <FaCar size={24} />, target: "car-insurance" },
    { label: "Bike", icon: <FaMotorcycle size={24} />, target: "bike-insurance" },
    { label: "Health", icon: <FaHeart size={24} />, target: "health-insurance" },
    { label: "Commercial", icon: <FaBriefcase size={24} />, target: "commercial-insurance" },
    { label: "Travel", icon: <FaPlane size={24} />, target: "travel-insurance" },
  ];

  return (
    <div style={{ width: "100%", paddingTop: "40px", paddingBottom: "40px" }}>
      <h2 className="section-title">
        What We Offer
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
          gap: "20px",
          width: "100%",
          maxWidth: "900px",
          margin: "0 auto"
        }}
      >
          {categories.map((item, index) => (
            <div
              key={index}
              style={{
                width: "100%",
                height: "140px",
                background: "#ffffff",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                transition: "0.3s ease",
                cursor: "pointer"
              }}
              onClick={() => navigate(`/products#${item.target}`)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)";
              }}
            >
              {item.icon}
              <p style={{ marginTop: "10px", fontWeight: 600 }}>{item.label}</p>
            </div>
          ))}
        </div>
    </div>
  );
}

export default Home;


